// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ImageWithPlaceholder_imageContainer__20WsI","image":"ImageWithPlaceholder_image__3ms2h","loadingPlaceholder":"ImageWithPlaceholder_loadingPlaceholder__1zQxH"};